import React from 'react';
import { timeStringToDate } from '@powerednow/components/fields/TimePicker';
import Box from '@powerednow/components/Box/Box';
import ACTION from '@powerednow/shared/constants/action';
import { formatDateToHoursAndMinutes } from '@powerednow/shared/modules/utilities/date';
import { ListItemCardProps } from 'FieldServices/react/features/workflow/ListItemCards/ListItemCardProps';

function AppointmentReminderListItemCard({ workflow, index }: ListItemCardProps) {
    if (!workflow?.settings) {
        return <Box>Invalid workflow configuration</Box>;
    }
    const amSendDate = timeStringToDate(workflow.settings.amReminderSendTime);
    const pmSendDate = timeStringToDate(workflow.settings.pmReminderSendTime);
    const showAm = ACTION.APPOINTMENT_REMINDER_SENDING_SCHEDULE[workflow.settings.reminderSendingSchedule].am;
    const showPm = ACTION.APPOINTMENT_REMINDER_SENDING_SCHEDULE[workflow.settings.reminderSendingSchedule].pm;

    return (
        <Box>
            <b>
                {ACTION.APPOINTMENT_REMINDER_SENDING_SCHEDULE[workflow.settings.reminderSendingSchedule].text}
            </b>
            {' send a reminder for upcoming appointments at '}
            <b>
                {formatDateToHoursAndMinutes(showAm ? amSendDate : pmSendDate)}
            </b>
            {showPm && showAm ? ' and ' : ''}
            <b>
                {showPm && showAm ? formatDateToHoursAndMinutes(pmSendDate) : ''}
            </b>
        </Box>
    );
}

export default AppointmentReminderListItemCard;
